module.exports = "/images/cover-11.jpg";